
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/fees-overview",
      function () {
        return require("private-next-pages/terms/fees-overview/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/fees-overview"])
      });
    }
  